export const handleIssuesResponse = response => {
  const {results, pagination} = response;
  results.forEach(result => Object.assign(result, {pagination}));
  return results;
};

export const mapEntityItems = addedLinks => ({
  items: addedLinks.map(addedLink => ({
    linkedItemId: addedLink.id,
    domain: addedLink.domain,
    linkedItemType: addedLink.type
  }))
});
